<template>
  <v-container>
    <v-row class="parent-row" justify="center" align-content="center">
      <v-col cols="12">
        <v-row justify="center">
          <h1 class="site-title">Welcome to Toy Box.</h1>
        </v-row>
        <v-row justify="center">
          <v-btn
            class="hiddenBtn"
            text
            v-bind:ripple="false"
            @click="onClickHiddenBtn"
          >
            <span class="description">This is Tomosibi's portal site.</span>
            <v-icon
              mediem
              color="#ff9380"
            >
              {{"mdi-emoticon-outline"}}
            </v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
  /* 親クラス"v-sheet"と同じ表示サイズを設定 */
  .container, .parent-row{
    /* position: relative; */
    height: 100%;
    width: 100%;
  }
 /* hiddenボタンをマウスオーバーした時の背景色の変更を無効化 */
  .hiddenBtn::before{
    background-color: transparent;
  }
  .site-title{
    font-size: 28px;
    color: white;
    letter-spacing: 2.0px;
    padding-bottom: 2px;
    text-shadow: 1px 2px 3px #808080;
  }
  .description{
    color: whitesmoke;
    font-size: 1.0rem;
    letter-spacing: 1.2px;
    text-transform: lowercase;
    text-shadow: 1px 2px 2px #808080;
  }
</style>

<script>
  export default {
    name: 'Home',
    data: () => ({
    }),
    methods:{
      /* Vuex StoreのhiddenBtnFlgを更新 */
      onClickHiddenBtn(){
        this.$store.commit('updateHiddenBtnFlg', !this.$store.state.hiddenBtnFlg)
      }
    }
  }
</script>
